
import React from 'react';
import AboutMe from 'components/aboutme';
import Footer from 'components/footer';

const About = () => {
    return (
        <div className='aboutBody'>

            <AboutMe />

            <div className='aboutContainerSection2'>

                <section className='aboutSection2'>


                    <div className='aboutQualificationHeadingDiv'>
                        <h1 data-aos="zoom-in" data-aos-offset="200"
                            data-aos-delay="50"
                            data-aos-duration="2000" >Qualification</h1>
                        <p data-aos="fade-right"
                            data-aos-offset="200"
                            data-aos-delay="50"
                            data-aos-duration="1000">My Personal Journy</p>
                    </div>

                    <div className='aboutQualificationEduContainer'>

                        <div className='aboutQualificationEduDiv'>
                            <h1 data-aos="fade-right"
                                data-aos-offset="200"
                                data-aos-delay="50"
                                data-aos-duration="2000">Education</h1>

                            <div data-aos="fade-up-right"
                                data-aos-offset="200"
                                data-aos-delay="50"
                                data-aos-duration="2000" className='eduItem1'>

                                <div className='eduSection1'>
                                    <span className='eduDate'> 2021-2024 </span> <br></br>
                                    BBA(CA) <br></br>
                                    <span className='eduStatus'> (currently persuing) </span>

                                </div>
                                <div className='eduSection2'>
                                    Suryadatta College of Management
                                    Information Research and Technology <br></br>
                                    <span className='eduDate'> Bavdhan, Pune </span>

                                </div>

                            </div>

                            <div data-aos="fade-up-right"
                                data-aos-offset="200"
                                data-aos-delay="50"
                                data-aos-duration="2000" className='eduItem1'>

                                <div className='eduSection1'>
                                    <span className='eduDate'> 2019-2020 </span> <br></br>
                                    Diploma in Graphic
                                    Design

                                </div>
                                <div className='eduSection2'>
                                    Design Vertex <br></br>
                                    <span className='eduDate'> Kothrud, Pune </span>

                                </div>

                            </div>

                            <div data-aos="fade-up-right"
                                data-aos-offset="200"
                                data-aos-delay="50"
                                data-aos-duration="2000" className='eduItem2'>

                                <div className='eduSection1'>
                                    <span className='eduDate'> 2021 </span> <br></br>
                                    H.S.C.

                                </div>
                                <div className='eduSection2'>
                                    Suryadatta Junior College  <br></br>
                                    <span className='eduDate'> Bavdhan, Pune </span>

                                </div>

                            </div>
                            <div data-aos="fade-up-right"
                                data-aos-offset="200"
                                data-aos-delay="50"
                                data-aos-duration="2000" className='eduItem3'>

                                <div className='eduSection1'>
                                    <span className='eduDate'> 2019 </span> <br></br>
                                    S.S.C.

                                </div>
                                <div className='eduSection2'>
                                    Modern Highschool  <br></br>
                                    <span className='eduDate'> Warje, Pune </span>

                                </div>

                            </div>


                        </div>

                        <div className='aboutQualificationEduDiv'>
                            <h1 data-aos="fade-right"
                                data-aos-offset="200"
                                data-aos-delay="50"
                                data-aos-duration="2000">Experience</h1>

                            <div data-aos="fade-up-left"
                                data-aos-offset="200"
                                data-aos-delay="50"
                                data-aos-duration="2000" className='eduItem1'>

                                <div className='eduSection1'>
                                    <span className='eduDate'> 2021-2022 </span> <br></br>
                                    Graphic Designer <br></br>

                                </div>
                                <div className='eduSection2'>
                                    Srujan Infotech <br></br>
                                    <span className='eduDate'> Erandwane, Pune </span>

                                </div>

                            </div>

                            <h1 data-aos="fade-right"
                                data-aos-offset="200"
                                data-aos-delay="50"
                                data-aos-duration="2000">Language</h1>


                            <div data-aos="fade-right"
                                data-aos-offset="200"
                                data-aos-delay="50"
                                data-aos-duration="1000" className='langItem'>

                                <p> English </p>
                                <svg width="200" height="10" viewBox="0 0 200 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="200" height="10" rx="5" fill="#D9D9D9" />
                                    <rect width="146" height="10" rx="5" fill="#202020" />
                                </svg>

                            </div>

                            <div data-aos="fade-right"
                                data-aos-offset="200"
                                data-aos-delay="50"
                                data-aos-duration="2000" className='langItem'>

                                <p> हिंदी </p>
                                <svg width="200" height="10" viewBox="0 0 200 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="200" height="10" rx="5" fill="#D9D9D9" />
                                    <rect width="174" height="10" rx="5" fill="#202020" />
                                </svg>

                            </div>
                            <div data-aos="fade-right"
                                data-aos-offset="200"
                                data-aos-delay="50"
                                data-aos-duration="3000" className='langItem'>

                                <p> मराठी </p>

                                <svg width="200" height="10" viewBox="0 0 200 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="200" height="10" rx="5" fill="#D9D9D9" />
                                    <rect width="194" height="10" rx="5" fill="#202020" />
                                </svg>

                            </div>

                            <h1 data-aos="fade-right"
                                data-aos-offset="200"
                                data-aos-delay="50"
                                data-aos-duration="2000">Interests</h1>

                            <div data-aos="fade-up"
                                data-aos-offset="200"
                                data-aos-delay="50"
                                data-aos-duration="2000" className='intrestItem'>
                                <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="30" cy="30" r="30" fill="#D9D9D9" />
                                    <path d="M43.1433 20.1366L37.5608 25.719L37.5755 25.7679L41.8148 41.3724C41.8874 41.7133 41.8786 42.0666 41.7891 42.4035C41.6995 42.7404 41.5318 43.0514 41.2996 43.3113L39.9003 44.7106C39.8098 44.8163 39.6941 44.8975 39.564 44.9466C39.4338 44.9958 39.2934 45.0113 39.1556 44.9919C39.0179 44.9724 38.8873 44.9185 38.7758 44.8352C38.6644 44.7519 38.5758 44.6419 38.5181 44.5153L32.7842 34.1367L30.9648 32.3149L26.154 37.1257C25.6026 37.6177 24.9864 38.0319 24.3225 38.3565L25.397 41.8901C25.4785 42.227 25.4769 42.5786 25.3922 42.9147C25.3076 43.2508 25.1424 43.5612 24.911 43.8193L24.4837 44.2491C24.2655 44.4656 23.9705 44.5871 23.6631 44.5871C23.3557 44.5871 23.0608 44.4656 22.8426 44.2491L20.3029 41.7118L20.2589 41.663L18.3346 39.7436L18.2858 39.6947L15.7509 37.1575C15.5344 36.9393 15.4129 36.6443 15.4129 36.3369C15.4129 36.0295 15.5344 35.7346 15.7509 35.5164L16.1807 35.0866C16.4392 34.8561 16.7499 34.6918 17.086 34.608C17.422 34.5242 17.7735 34.5234 18.1099 34.6055L21.6436 35.6751C21.9685 35.0114 22.3826 34.3952 22.8744 33.8436L27.6852 29.0328L25.8634 27.216L15.4847 21.4821C15.3581 21.4244 15.2481 21.3358 15.1648 21.2244C15.0815 21.113 15.0276 20.9823 15.0081 20.8446C14.9887 20.7068 15.0042 20.5664 15.0534 20.4362C15.1025 20.3061 15.1837 20.1904 15.2894 20.0999L16.6887 18.7006C16.9487 18.4686 17.2598 18.301 17.5966 18.2115C17.9335 18.1219 18.2867 18.113 18.6276 18.1854L34.2323 22.4247L34.2811 22.4394L39.8637 16.8569C40.7672 15.9485 43.8222 14.3661 44.7306 15.2696C45.6342 16.178 44.0493 19.2306 43.1433 20.1366Z" fill="black" />
                                </svg>
                                <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="30" cy="30" r="30" fill="#D9D9D9" />
                                    <path d="M15 27V33" stroke="black" stroke-width="3" stroke-linecap="round" />
                                    <path d="M39 27V33" stroke="black" stroke-width="3" stroke-linecap="round" />
                                    <path d="M21 21V39" stroke="black" stroke-width="3" stroke-linecap="round" />
                                    <path d="M33 21V39" stroke="black" stroke-width="3" stroke-linecap="round" />
                                    <path d="M45 21V39" stroke="black" stroke-width="3" stroke-linecap="round" />
                                    <path d="M27 15V45" stroke="black" stroke-width="3" stroke-linecap="round" />
                                </svg>
                                <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="30" cy="30" r="30" fill="#D9D9D9" />
                                    <path d="M39.6251 27.9784H21.3748C16.7496 27.9784 13 31.7884 13 36.4892C13 41.1894 16.7496 45 21.3748 45C24.2903 45 26.8567 43.4851 28.3568 41.1894H32.6432C34.1432 43.4851 36.7097 45 39.6252 45C44.2503 45 48 41.1894 48 36.4892C47.9999 31.7884 44.2502 27.9784 39.6251 27.9784ZM22.8715 42.1644C19.787 43.0043 16.6169 41.1442 15.7903 38.0102C14.9637 34.8756 16.7941 31.654 19.8786 30.814C22.9626 29.974 26.1333 31.8347 26.9598 34.9681C27.7864 38.1028 25.9561 41.325 22.8715 42.1644ZM41.1218 42.1644C38.0366 43.0044 34.8666 41.1443 34.04 38.0096C33.2145 34.8756 35.0444 31.6541 38.1284 30.814C41.2129 29.974 44.3836 31.8347 45.2101 34.9681C46.0361 38.1028 44.2057 41.325 41.1218 42.1644Z" fill="black" />
                                    <path d="M22.4591 32.5944H20.2089V35.2192H17.626V37.5059H20.2089V40.1308H22.4591V37.5059H25.0425V35.2192H22.4591V32.5944Z" fill="black" />
                                    <path d="M40.5233 34.5164C41.0205 34.0111 41.0205 33.1928 40.5233 32.6876C40.0266 32.1828 39.2209 32.1828 38.7236 32.6876C38.2269 33.1929 38.2269 34.0111 38.7236 34.5164C39.2208 35.0212 40.0266 35.0212 40.5233 34.5164Z" fill="black" />
                                    <path d="M41.5669 35.575C41.0702 36.0798 41.0702 36.898 41.5669 37.4034C42.0636 37.9087 42.8692 37.9087 43.366 37.4034C43.8633 36.898 43.8633 36.0798 43.366 35.575C42.8692 35.0697 42.0636 35.0697 41.5669 35.575Z" fill="black" />
                                    <path d="M35.8842 35.575C35.3869 36.0798 35.3869 36.898 35.8842 37.4034C36.3809 37.9087 37.186 37.9087 37.6827 37.4034C38.1799 36.898 38.1799 36.0798 37.6827 35.5745C37.186 35.0697 36.3809 35.0697 35.8842 35.575Z" fill="black" />
                                    <path d="M38.7236 38.462C38.2269 38.9673 38.2269 39.7856 38.7236 40.2904C39.2208 40.7957 40.0266 40.7957 40.5233 40.2904C41.0205 39.7856 41.0205 38.9674 40.5238 38.462C40.0266 37.9567 39.2208 37.9578 38.7236 38.462Z" fill="black" />
                                    <path d="M31.383 19.9188C31.383 19.7492 31.416 19.592 31.4763 19.4469C31.5664 19.2305 31.7189 19.0443 31.9095 18.9132C32.101 18.7821 32.3255 18.7073 32.5763 18.7062C32.7432 18.7068 32.8979 18.7408 33.04 18.8016C33.253 18.8925 33.4373 19.0475 33.5658 19.2422C33.6948 19.4363 33.7688 19.6644 33.7694 19.9187C33.7689 20.3293 33.8517 20.7253 34.0005 21.0833C34.225 21.621 34.5971 22.0762 35.0663 22.3985C35.5345 22.7209 36.1059 22.9099 36.7124 22.9099C37.1157 22.9099 37.5054 22.8263 37.8583 22.674C38.3869 22.4471 38.8347 22.0683 39.152 21.592C39.4692 21.1156 39.6559 20.5356 39.6552 19.9187V15H37.905V19.9188C37.905 20.0889 37.872 20.2462 37.8117 20.3907C37.7217 20.6071 37.5691 20.7939 37.3787 20.925C37.1871 21.0555 36.9626 21.1314 36.7124 21.1319C36.545 21.1314 36.3901 21.0979 36.248 21.0366C36.0351 20.9451 35.8512 20.79 35.7222 20.5959C35.5932 20.4018 35.5197 20.1731 35.5192 19.9187C35.5192 19.5087 35.4369 19.1128 35.2876 18.7553C35.0631 18.2165 34.691 17.7614 34.2217 17.4395C33.7536 17.1166 33.1822 16.9281 32.5763 16.9281C32.1723 16.9281 31.7826 17.0117 31.4297 17.1635C30.9012 17.391 30.4528 17.7692 30.1361 18.2461C29.8188 18.7224 29.6322 19.3024 29.6328 19.9187V27.1935H31.3831V19.9188H31.383Z" fill="black" />
                                </svg>

                            </div>


                        </div>


                    </div>

                </section>

            </div>

            <Footer />

        </div>
    );
};

export default About;